import Field from "@/components/form/Field.tsx";
import CompanyComboBox from "@/components/editor/fields/CompanyComboBox.tsx";
import {Company, Item} from "@/types/Company";
import {useContext} from "react";
import {FormContext} from "@/components/form/Form.tsx";

export default function CompanySelectField({name, onCompanyLoad}: {
    name: string,
    onCompanyLoad: (company: Company) => void
}) {
    const form = useContext(FormContext)

    function onCompanyChange(company: Company) {
        onCompanyLoad(company)
        //load members into the form
        const groups = company.data.groups.filter((group) => group.title.includes("tagok adatai") && group.type === "members")
        const memberData: Item[] = groups.flatMap((group) => group.items)
        const members: any[] = []
        if (memberData) {
            for (const item of memberData) {
                if (item.valid) {
                    const nameRegex = / \(an.:[\w\W]*\)/g
                    //TODO: members consist only of persons -> find where companys are listed

                    // @ts-ignore
                    const birth_date = new Date(item.rows.find((row) => row.key === "Születési dátum")?.value.replaceAll('.', '-').substring(0, 10))
                    const isPerson = item.rows.find((row) => row.key === "Születési dátum")?.value !== undefined
                    const a = isPerson ? Math.floor((Date.now() - Date.parse(birth_date.toDateString())) / (24 * 3600 * 1000) / 365) : 0
                    const age = a > 0 ? a : 0
                    const member = {
                        general: {
                            // @ts-ignore
                            name: item.rows.find((row) => row.key === "Név")?.value.replaceAll(nameRegex, '').replaceAll("Korlátolt Felelősségű Társaság", "Kft."),
                            birth_date: birth_date,
                            isPerson: isPerson,
                            first_meet: false,
                            cover: false,
                            szindikatus: {value: 100000, valuta: "HUF"},
                            tulajdonosi_resz: 100,
                        },
                        nyugdij: {
                            mod: "kamat",
                            monthly_need: {value: 100000, valuta: "HUF"},
                            monthly_actual: {value: 100000, valuta: "HUF"},
                            slider: [age, age >= 65 ? age + 1 : 65, age >= 65 ? 100 : 75],
                            longtext: "-",
                            szja: false
                        }
                    }
                    if (!(form.getValue('cegkepviseletArray') ?? []).find((m: any) => m.general.name === member.general.name)) {
                        members.push(member)
                    }
                }

            }
        }
        form.setValues({'cegkepviseletArray': [...(form.getValue('cegkepviseletArray') ?? []), ...members], [name]: company.summary.details.registrationNumber.value})
        form.setTouchedField('cegkepviseletArray', members.map(() => ({})))
        form.touchField(name)
        form.setError('cegkepviseletArray', members.map(() => ({})))
    }

    return (
        <Field name={name}>
            {(field) => (
                <CompanyComboBox registrationNumber={field.value} onCompanyChange={(regNum, company) => {
                    if (regNum !== field.value) {
                        field.onChange(regNum)
                        onCompanyChange(company)
                    }
                    onCompanyLoad(company)
                }}/>
            )}
        </Field>

    )
}